import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {TemplatesList} from '@mintdata-wsp/wsp/ui/views/workspace/home/templates/TemplatesList';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./TemplatesPage.less');
const cx = classnames.bind(styles);

@observer
export class TemplatesPage extends BasePage<RouteComponentProps<any>, any>
{
    render()
    {
        const {templatesByCategory} = controllers.ui.mainPage;

        return (
            <Column className={cx(styles.page)}>

                <TemplatesList
                    // filterType={DesignsFilterType.Designs}
                    templates={templatesByCategory}
                    // newDesign={true}
                />

            </Column>
        );
    }

}
